// PostCard 组件 - 博客文章卡片
import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const PostCard = ({ post, variant = 'default', showAuthor = true, showExcerpt = true }) => {
  // 格式化日期
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('zh-CN', options);
  };

  // 计算阅读时间
  const calculateReadTime = (text) => {
    const wordsPerMinute = 200;
    const words = text.trim().split(/\s+/).length;
    const minutes = Math.ceil(words / wordsPerMinute);
    return `${minutes}分钟阅读`;
  };

  // 根据变体设置卡片样式类
  const cardClass = `post-card ${variant} ${showAuthor ? 'with-author' : 'without-author'}`;

  return (
    <article className={cardClass}>
      {/* 文章封面图片 */}
      {post.image && (
        <div className="post-image">
          <img src={post.image} alt={post.title} />
        </div>
      )}

      <div className="post-content">
        {/* 标签和分类 */}
        <div className="post-meta-top">
          <div className="post-categories">
            {post.categories?.map((category, index) => (
              <span key={index} className="category-tag">
                {category}
              </span>
            ))}
          </div>
          {post.featured && (
            <span className="featured-badge">精选</span>
          )}
        </div>

        {/* 标题 */}
        <h2 className="post-title">
          <Link to={`/post/${post.id}`} className="post-link">
            {post.title}
          </Link>
        </h2>

        {/* 摘要 */}
        {showExcerpt && post.excerpt && (
          <p className="post-excerpt">{post.excerpt}</p>
        )}

        {/* 底部元信息 */}
        <div className="post-meta-bottom">
          {showAuthor && post.author && (
            <div className="post-author">
              <div className="author-avatar">
                <img 
                  src={post.author.avatar || 'https://via.placeholder.com/40'} 
                  alt={post.author.name} 
                />
              </div>
              <div className="author-info">
                <span className="author-name">{post.author.name}</span>
              </div>
            </div>
          )}

          <div className="post-details">
            <span className="post-date" title={formatDate(post.date)}>
              {formatDate(post.date)}
            </span>
            <span className="post-read-time">
              🕐 {calculateReadTime(post.content || post.excerpt || '')}
            </span>
            {post.comments !== undefined && (
              <span className="post-comments">
                💬 {post.comments} 条评论
              </span>
            )}
          </div>
        </div>

        {/* 标签 */}
        {post.tags && post.tags.length > 0 && (
          <div className="post-tags">
            {post.tags.map((tag, index) => (
              <span key={index} className="tag">
                #{tag}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* 互动按钮 */}
      <div className="post-actions">
        <button className="action-button like-button" aria-label="点赞">
          <span className="heart-icon">❤️</span>
          <span className="like-count">{post.likes || 0}</span>
        </button>
        <button className="action-button bookmark-button" aria-label="收藏">
          <span className="bookmark-icon">🔖</span>
        </button>
        <Link to={`/post/${post.id}#comments`} className="action-button comment-button" aria-label="评论">
          <span className="comment-icon">💬</span>
        </Link>
      </div>
    </article>
  );
};

export default PostCard;